import React from 'react';
import { StarIcon, TrophyIcon, CheckCircleIcon } from 'lucide-react';
import { MatchedSchool } from '../services/matchingApi';
interface MatchedSchoolCardProps {
  school: MatchedSchool;
  index: number;
}
export function MatchedSchoolCard({
  school,
  index
}: MatchedSchoolCardProps) {
  const name = (school.mBrandName || school.brandName || school.schoolname || '') as string;
  const headline = (school.headContent || school.headline || '') as string;
  const bodyHtml = (school.bodyContent || '') as string;
  const logo = (school.imageURL || school.logoUrl || school.logourl || '') as string;
  const clickUrl = (school.clickURL || school.clickUrl || school.url || '') as string;
  const badge = (school.ribbonText || school.badge || '') as string;
  const position = (school.mPosition || index + 1) as number;
  const isFirst = index === 0;
  const schoolInitials = (name || 'SC').split(' ').filter(w => w.length > 0).map(w => w[0]).join('').substring(0, 3).toUpperCase();
  return <div className="relative" data-id="element-382">
      {/* #1 Recommended School Banner */}
      {isFirst && <div className="rounded-t-xl px-4 py-3 flex items-center justify-center gap-2 bg-[#1B365D]" data-id="element-383">
          <TrophyIcon className="w-4 h-4 text-[#D4A843]" data-id="element-384" />
          <span className="text-white text-sm font-bold tracking-wide" data-id="element-385">
            #1 Recommended School
          </span>
        </div>}

      <div className={`bg-white overflow-hidden transition-shadow duration-200 ${isFirst ? 'rounded-b-xl border-2 border-t-0 border-[#1B365D]/20 shadow-lg' : 'rounded-xl border border-gray-200 shadow-sm hover:shadow-md'}`} data-id="element-386">
        {/* Badge */}
        {badge && <div className="px-5 pt-4" data-id="element-387">
            <span className="inline-flex items-center gap-1.5 bg-[#1B365D] text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-388">
              <StarIcon className="w-3 h-3 fill-current text-[#D4A843]" data-id="element-389" />
              {badge}
            </span>
          </div>}

        <div className="p-5 sm:p-6 flex flex-col md:flex-row gap-5" data-id="element-390">
          {/* Left: Rank + Content */}
          <div className="flex-1 flex gap-4 min-w-0" data-id="element-391">
            {/* Rank Number */}
            <div className="flex-shrink-0 pt-1" data-id="element-392">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isFirst ? 'bg-[#1B365D] text-white' : 'border-2 border-gray-200 text-gray-400'}`} data-id="element-393">
                <span className="text-sm font-bold" data-id="element-394">{position}</span>
              </div>
            </div>

            {/* School Info */}
            <div className="flex-1 min-w-0" data-id="element-395">
              <h3 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-396">
                {name}
              </h3>

              {headline && <p className="text-sm text-gray-600 mt-1 mb-3 leading-relaxed" data-id="element-397">
                  {headline}
                </p>}

              {/* Body Content - rendered as HTML (contains <ul><li> bullet points) */}
              {bodyHtml && <div className="school-body-content text-sm text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{
              __html: bodyHtml
            }} data-id="element-398" />}
            </div>
          </div>

          {/* Right: Logo + CTA */}
          <div className="flex flex-row md:flex-col items-center md:items-center justify-between md:justify-start gap-4 md:w-40 flex-shrink-0" data-id="element-399">
            {/* Logo */}
            <div className="w-36 h-24 flex items-center justify-center p-1" data-id="element-400">
              {logo ? <img src={logo} alt={`${name} logo`} className="max-w-full max-h-full object-contain" onError={e => {
              ;
              (e.target as HTMLImageElement).style.display = 'none';
              const next = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
              if (next) next.style.display = 'flex';
            }} data-id="element-401" /> : null}
              <div className={`w-full h-full items-center justify-center ${logo ? 'hidden' : 'flex'}`} data-id="element-402">
                <span className="text-sm font-bold text-navy" data-id="element-403">
                  {schoolInitials}
                </span>
              </div>
            </div>

            {/* CTA Button */}
            {clickUrl ? <a href={clickUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3 text-sm font-bold rounded-lg text-white bg-[#A52A2A] hover:bg-[#8B1A1A] transition-colors duration-200 whitespace-nowrap shadow-md hover:shadow-lg" data-id="element-404">
                View Programs
              </a> : null}

            {/* 100% Online */}
            <div className="flex items-center gap-1.5 text-xs font-semibold text-gray-600" data-id="element-405">
              <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-406" />
              100% Online
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function DidYouKnowBanner() {
  return <div className="flex items-center justify-center gap-2 py-3 text-sm text-gray-600" data-id="element-407">
      <span className="text-lg" data-id="element-408">💡</span>
      <span className="font-bold text-gray-800" data-id="element-409">DID YOU KNOW?</span>
      <span data-id="element-410">Enrollments increased by 40% this year</span>
    </div>;
}